import React from 'react';
import { useParams } from 'react-router-dom';

const DoctorDetail = () => {
  const { id } = useParams();
  
  return (
    <div className="doctor-detail-page">
      <div className="page-header">
        <div className="container">
          <h1>Doctor Details</h1>
        </div>
      </div>
      <div className="container section">
        <p>Doctor details page for ID: {id} - To be implemented</p>
      </div>
    </div>
  );
};

export default DoctorDetail;
